import React from 'react';
import { ArrowRightIcon, LockKeyholeIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { DialogueCard } from '../story/DialogueCard';
import { ChipGroup } from '../story/ChipGroup';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { privacyCopy, wateringMapFields } from '../../data/tools';
import { AMARA_MENTOR } from '../../data/speakers';
export function WateringMapScreen() {
  const {
    state,
    dispatch,
    announce
  } = useDemo();
  const values = state.fieldGuideSelections.wateringMap;
  const status = state.fieldGuideSelections.wateringMapStatus;
  return <ScreenContainer data-id="element-313" data-mp="2aaxr18ok9ttr">
      <ScreenHeading eyebrow="Safe Watering Hole Map" data-id="element-314" data-mp="4fwn4pc11yo2">A small plan can be a safe route.</ScreenHeading>
      <div className="mt-5 max-w-2xl" data-id="element-315" data-mp="8h87ogg1ntpe">
        <DialogueCard line={{
        kind: 'speech',
        speaker: AMARA_MENTOR,
        text: 'You can use this for me, an animal, or yourself. You do not have to tell your own story.'
      }} data-id="element-316" data-mp="8g6w8av49575" />
      </div>

      <div className="mt-6 grid gap-6 lg:grid-cols-[1fr_340px] lg:items-start" data-id="element-317" data-mp="anjkwbor4fg7">
        <div className="flex flex-col gap-4" data-id="element-318" data-mp="apm7smulxsgp">
          {wateringMapFields.map(field => <ChipGroup key={field.id} legend={field.question} options={field.options} value={values[field.id]} onSelect={option => dispatch({
          type: 'SET_TOOL_FIELD',
          tool: 'wateringMap',
          field: field.id,
          value: option
        })} data-id="element-319" data-mp="5qjf81vtdepm" />)}
        </div>
        <aside className="rounded-2xl border-2 border-teal bg-paper p-5 lg:sticky lg:top-24" aria-label="Map preview" data-id="element-320" data-mp="3j2bd3kd237xl">
          <h2 className="font-display text-xl font-semibold text-forest" data-id="element-321" data-mp="13anjnyx93xjj">Your map, this visit</h2>
          <ol className="mt-4 flex flex-col gap-3 border-l-4 border-[#4E8C86] pl-4" data-id="element-322" data-mp="yclzfao39s6h">
            {wateringMapFields.map(field => <li key={field.id} data-id="element-323" data-mp="1afexefiju0qt">
                <p className="text-sm font-bold text-teal" data-id="element-324" data-mp="1aelvbrujbzf0">{field.question}</p>
                <p className={values[field.id] ? 'text-ink' : 'text-ink/80'} data-id="element-325" data-mp="1ferlf3l5pduz">{values[field.id] ?? 'Open'}</p>
              </li>)}
          </ol>
          <p role="status" className="mt-4 text-sm font-bold text-forest" data-id="element-326" data-mp="1kctbi8h02dfy">
            {status === 'kept' ? 'Kept for this visit.' : status === 'blank' ? 'Left blank. Still yours to use.' : ''}
          </p>
        </aside>
      </div>

      <p className="mt-6 flex max-w-3xl items-start gap-3 rounded-2xl bg-sand p-5" data-id="element-327" data-mp="woa4rxdlm8pz">
        <LockKeyholeIcon size={20} className="mt-1 shrink-0 text-teal" aria-hidden="true" data-id="element-328" data-mp="wm5pyke5vpax" />
        {privacyCopy}
      </p>

      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-329" data-mp="3zus3hhxw2ht">
        <Button variant="secondary" onClick={() => {
        dispatch({
          type: 'SET_TOOL_STATUS',
          tool: 'wateringMap',
          status: 'blank'
        });
        announce('Left blank. Still yours to use.');
      }} data-id="element-330" data-mp="3x8m3map5v1p">
          Leave blank
        </Button>
        <Button variant="secondary" onClick={() => {
        dispatch({
          type: 'SET_TOOL_STATUS',
          tool: 'wateringMap',
          status: 'kept'
        });
        announce('Kept for this visit.');
      }} data-id="element-331" data-mp="2i7lxc765zh7p">
          Keep for this visit
        </Button>
        <Button onClick={() => dispatch({
        type: 'GO',
        screen: 'echo'
      })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-333" data-mp="1yiuy05gf7cli" />} data-id="element-332" data-mp="23a3d9i4fls6l">
          Continue
        </Button>
      </ActionRow>
    </ScreenContainer>;
}